export default __webpack_public_path__ + "static/media/ic_peo_go.ad8e0457.png";